var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundpatterndecorative02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 216,
    viewBox: "0 0 216 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10883_28135",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -120,
    y: -120,
    width: 336,
    height: 336
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 336,
    transform: "translate(-120 -120)",
    fill: "url(#paint0_radial_10883_28135)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10883_28135)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 47.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 47.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 71.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 95.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 119.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 143.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 167.5,
    stroke: "#EAECF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10883_28135",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168 168) rotate(90) scale(168 168)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundpatterndecorative02);
export default __webpack_public_path__ + "static/media/Background pattern decorative-02.80166e7c6871d1287327357685fdd052.svg";
export { ForwardRef as ReactComponent };